<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="visibleFields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(index)="data">
						{{ data.index + 1 }}
					</template>
					<template v-slot:cell(nominativo)="row">
						<b-container class="bv-example-row">
							<span>{{ row.item.cognome }} {{ row.item.nome }}</span>
						</b-container>
					</template>
					<template v-slot:cell(tempo)="row">
						<b-container class="bv-example-row">
							<span>{{ formatFloat(row.item.tempoLavorazione, 2) }} ({{ row.item.oreLavorazione }})</span>
						</b-container>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-if="!row.item.dataOraFine" v-b-tooltip.hover size="sm" variant="outline-danger" title="Fine Task" @click="onClickFineTask(row.item, row.index, $event.target)" class="mr-1 no-text">
								<i class="far fa-calendar-times"></i>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
		<b-modal ref="mdlFineTask" size="sm" title="Fine Attività" @ok="onOkChiudiTask">
			<date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="dataOraFineTask" type="datetime"></date-picker>
		</b-modal>
	</div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	props: {
		visualizzaColonna: {
			type: Boolean,
			default: function () {
				return true;
			},
		},
	},
	mixins: [UtilityMixin],
	components: { DatePicker },
	computed: {
		visibleFields() {
			return this.fields.filter((field) => field.visible);
		},
	},
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/gestioneattivitatasklavorodipendente",
			pathResourceChiudiTask: "/gestioneattivitatasklavorodipendente/chiudi",
			linkedit: "/gestioneattivita/tasks",
			tasksFilter: {},
			btnAggiungi: false,
			dataOraFineTask: null,
			taskSelezionato: null,
			items: [],
			fields: [
				{
					label: "#",
					key: "index",
					sortable: true,
					thStyle: "width: 3rem",
					visible: true,
				},
				{
					label: "Mansione",
					key: "mansione",
					sortable: true,
					visible: this.visualizzaColonna,
				},
				{
					label: "Nominativo",
					key: "nominativo",
					sortable: true,
					visible: true,
				},
				{
					label: "Data Inizio",
					key: "dataOraInizio",
					thStyle: "width: 12rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
						} else {
							return "-----";
						}
					},
					sortable: true,
					visible: true,
				},
				{
					label: "Data Fine",
					key: "dataOraFine",
					thStyle: "width: 12rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
						} else {
							return "-----";
						}
					},
					sortable: true,
					visible: true,
				},
				{
					label: "Tempo di Lavorazione",
					key: "tempo",
					thStyle: "width: 3rem",
					sortable: true,
					visible: true,
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "", visible: true },
			],
		};
	},
	methods: {
		init(params) {
			let me = this;
			me.tasksFilter = params;
			me.loadData();
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource, me.tasksFilter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.$emit("afterLoadData", me.items);
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
		onClickFineTask(item) {
			let me = this;
			me.taskSelezionato = item;
			me.dataOraFineTask = new Date().getTime();
			me.$refs.mdlFineTask.show();
		},
		onClickDetails(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/dettaglio/" + item.id).catch((err) => {
				err;
			});
		},
		onOkChiudiTask() {
			let me = this;
			let body = { dataOraFine: me.dataOraFineTask };
			let link = process.env.VUE_APP_PATH_API + me.pathResourceChiudiTask + "/" + me.taskSelezionato.id;
			UtilityMixin.methods.restCallPut(link, body, me.onOkChiudiTaskSuccess, me.onOkChiudiTaskErrors);
		},
		onOkChiudiTaskSuccess(response) {
			console.log(response);
			let me = this;
			me.$emit("update");
		},
		onOkChiudiTaskErrors(error) {
			this.$bvModal
				.msgBoxOk(error.response.data.messaggio, {
					title: "ATTENZIONE",
					size: "sm",
					okVariant: "outline-danger",
					headerClass: "sa-msg-header-danger",
					footerClass: "p-2 border-top-0",
					centered: true,
				})
				.then((value) => {
					console.log(value);
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style></style>
